import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-under-liquidition',
  templateUrl: './under-liquidition.component.html',
  styleUrls: ['./under-liquidition.component.scss']
})
export class UnderLiquiditionComponent implements OnInit {


  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  societiesData: any[] = [];
  circlesList: any[] = [];
  consumerGoodsForm!: FormGroup;
  societiesForm!: FormGroup;
  rows: any[] = [];
  months: any[] = [];
  showButton = false
  currentMonth: any = {};
  monthKeyMap: Record<number, string> = {
    1: 'april',
    2: 'may',
    3: 'june',
    4: 'july',
    5: 'august',
    6: 'september',
    7: 'october',
    8: 'november',
    9: 'december',
    10: 'january',
    11: 'february',
    12: 'march'
  };
  constructor(private reportService: ReportsService, private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });
    this.initForm()
    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;

    switch (this.UserDetails?.roleId) {
      case 13:

        break;
      case 1:
        this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
        this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();


        break;
      default:
    }
    this.targetForm.valueChanges
      .pipe(debounceTime(300))  // waits 300ms after last change
      .subscribe(values => {
        if (this.targetForm.valid) {
          this.GetSocietyAndLiquidationData();
        }
      });


    const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"


    // this.GetConsumerGoods();.


    this.getTargetCount();
    this.GetYearAndMonth();

  }

  initForm() {
    this.societiesForm = this.fb.group({
      // These are display-only fields (not part of submission)
      financialYear: [{ value: '', disabled: true }],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }],
      dataMonth: [{ value: '', disabled: false }],
      societiesULStart: [{ value: 0, disabled: false }],

      // Editable fields with validations
      societiesPutUL: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      societiesWoundUp: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      societiesRevived: ['', [Validators.required, Validators.pattern(/^\d+$/)]],

      pendencyLessThan2Years: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      pendency2To5Years: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      pendencyAbove5Years: ['', [Validators.required, Validators.pattern(/^\d+$/)]]
    });

  }

  get f() {
    return this.societiesForm.controls;
  }

  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if (this.UserDetails?.roleId !== 1) {
          this.blockList = res.data.blocks;
        }

        this.financialYears = res.data.financialYears
        if (this.UserDetails?.roleId == 11) {
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
          this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {

    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;

      }
    },
      (error: any) => {
      }
    );
  }

  GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId": 0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }


    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {

        this.blockList = res.data?.block;
        this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }
  GetYearAndMonth() {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        // this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }
  GetSocietyAndLiquidationData() {
    let obj = {
      blockId: this.targetForm.getRawValue().blockOffice.toString(),
      "financialYear": this.targetForm.value?.financialYear?.financialYear
    }
    this.reportService.GetSocietyAndLiquidationData(obj).subscribe((res: any) => {

      if (res && res?.data && res?.data.length > 0) {

        let lastRow = res?.data[res?.data.length - 1];

        this.societiesData = res?.data
        if (Number(lastRow?.monthId) != 12 && Number(lastRow?.monthId) < 12) {
          let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
          let year = (Number(lastRow?.monthId) <= 9) ? fyear?.split('-')[0] : fyear.split('-')[1]
          this.currentMonth.key = (Number(lastRow?.monthId) + 1).toString();
          this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.monthId) + 1)] + ', ' + year
          this.showButton = true
        } else {
          this.showButton = false
          this.societiesData = []
          this.initForm();

          this.currentMonth.key = '1';
          this.toastService.showInfo('NO Data Found!')
        }


      } else {
        this.societiesData = []
        this.showButton = true;
        this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
        this.currentMonth.key = '1';
        this.toastService.showInfo('NO Data Found!')
      }
    },
      (error: any) => {
      }
    );
  }

  addData() {
    let lastItem
    if (this.societiesData && this.societiesData.length > 0) {
      lastItem = this.societiesData[this.societiesData.length - 1]
    }

    this.societiesForm.patchValue({
      financialYear: this.targetForm.value?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth: this.currentMonth.key,
      societiesULStart: lastItem ? this.calculateBalance(lastItem) : 0

    });
    if (lastItem) {
      this.societiesForm.get('societiesULStart')?.disable();

    } else {
      this.societiesForm.get('societiesULStart')?.enable();
    }

  }


  onSubmit() {
    if (this.societiesForm.valid) {


      // let entryYear = this.reportingYears.find((i) => i?.startYear == payload?.offilneEntryYear)
      const formValues = this.societiesForm.getRawValue(); // includes disabled fields

      const payload = {

        financialYear: formValues?.financialYear?.financialYear?.toString(), // '2025-26'
        blockOffice: +formValues?.blockOffice,                          // set actual ID here
        monthId: +formValues.dataMonth || 0,     // assuming dataMonth is month number as string

        societyUL: formValues.societiesULStart?.toString() || '0',
        societyPutUL: formValues.societiesPutUL,
        societyWoundUP: formValues.societiesWoundUp,
        societyRevived: formValues.societiesRevived,

        pendencyLessThan1Year: formValues.pendencyLessThan2Years,
        pendency2To5Year: formValues.pendency2To5Years,
        pendencyAbove5Year: formValues.pendencyAbove5Years,
        "createdBy": this.edit ? 0 : this.UserDetails?.id,
        "modifiedBy": this.edit ? this.UserDetails?.id : 0,
        id: this.edit ? this.editId : 0
      };



      this.reportService.AddSocietyLiquidationDetail(payload).subscribe((res: any) => {
        if (res) {

          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('CooperativeSocietiesUnderLiquidationDataModal');
            this.societiesForm.reset();
            this.societiesForm.markAsUntouched();
            this.GetSocietyAndLiquidationData();
            this.edit = false
            this.editId = 0;
          } else {
            this.toastService.showError(res.message);
          }

        }

      },
        (error: any) => {
        }
      );


    } else {
      this.societiesForm.markAllAsTouched();
    }
  }

  edit = false;
  editId = 0


  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }


  editRow(row: any) {

    const data = row;
    const headerData = this.targetForm.getRawValue();
    // Patch disabled controls separately
    // this.societiesForm.get('financialYear')?.setValue( headerData?.financialYear?.financialYear?.toString(),);
    this.societiesForm.get('blockOffice')?.setValue(data.blockOffice);

    // Patch enabled controls
    this.societiesForm.patchValue({
      "financialYear": headerData?.financialYear,
      dataMonth: data.monthId.toString(),
      societiesULStart: data.societyUL,
      societiesPutUL: data.societyPutUL,
      societiesWoundUp: data.societyWoundUP,
      societiesRevived: data.societyRevived,
      pendencyLessThan2Years: data.pendencyLessThan1Year,
      pendency2To5Years: data.pendency2To5Year,
      pendencyAbove5Years: data.pendencyAbove5Year
    });



    this.editId = data?.id
    this.edit = true

    this.openModal('CooperativeSocietiesUnderLiquidationDataModal');
  }
  closeModel() {
    this.societiesForm.reset()
    this.societiesForm.markAsUntouched()
    this.editId = 0
    this.edit = false
  }

  DeleteLiquiditionData(id: any) {
    this.reportService.DeleteSocietyAndLiquidation(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetSocietyAndLiquidationData();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyLiquiditionData(id: any) {
    this.reportService.verifySocietyAndLiquidation(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetSocietyAndLiquidationData();
        }

      }
    },
      (error: any) => {
      }
    );
  }
  getMonthName(month: string | number): string {
    const months = [
      'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December', 'January', 'February', 'March'
    ];
    const index = +month - 1;
    return months[index] || 'Unknown';
  }

  getYearFromFinancialYear(financialYear: string, month: string | number): string {
    const [startYear, endYear] = financialYear.split('-');
    const monthNum = +month;
    return monthNum >= 1 && monthNum <= 9 ? startYear : endYear;
  }


  calculateBalance(row: any): number {
    const start = +row.societyUL || 0;
    const putUL = +row.societyPutUL || 0;
    const woundUp = +row.societyWoundUP || 0;
    const revived = +row.societyRevived || 0;
    return start + putUL - woundUp - revived;
  }
  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete() {
    this.deleteIndex = 0;

  }
}
